export enum GoogleAdsRequestTypeGq {
  LONG_TAIL = 'LONG_TAIL',
  RELATED = 'RELATED',
  SITE = 'SITE',
  EXACT = 'EXACT',
  URL = 'URL',
  CATEGORY = 'CATEGORY',
  LEGACY = 'LEGACY',
  COPY = 'COPY',
}
